import { ChangeDetectorRef, Component, EventEmitter, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as braintree from 'braintree-web';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';


@Component({
  standalone: true,
  selector: 'equine-ui-nx-payment-method-add-credit-card-dialog',
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './payment-method-add-credit-card-dialog.component.html',
  styleUrl: './payment-method-add-credit-card-dialog.component.scss',
})
export class PaymentMethodAddCreditCardDialogComponent implements OnInit {
  public readonly data = inject<{clientInstance: any, overrideButtonLabel?: string}>(MAT_DIALOG_DATA);
  
  hostedFieldsInstance!: braintree.HostedFields;
  disablePayButton = true;
  cardholdersName!: string;
  paying = signal(false);

  creditCardTokenized = new EventEmitter<{nonce: string}>();

  constructor(
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.createBraintreeCreditCardHostedFields();
  }

  createBraintreeCreditCardHostedFields() {
    braintree.hostedFields.create({
      client: this.data.clientInstance,
      styles: {
        'input': {
          'font-size': '16px',
          'font-family': 'roboto, verdana, sans-serif',
          'font-weight': 'lighter',
          'color': '#1A1C1C'
        },
        ':focus': {
          'color': '#1A1C1C'
        },
        '.valid': {
          'color': '#1A1C1C'
        },
        '.invalid': {
          'color': '#AB2D25'
        }
      },
      fields: {
        number: {
          selector: '#card-number',
          placeholder: '1111 1111 1111 1111'
        },
        cvv: {
          selector: '#cvv',
          placeholder: '111'
        },
        expirationDate: {
          selector: '#expiration-date',
          placeholder: 'MM/YY'
        },
        cardholderName: {
          selector: '#card-holder-name',
          placeholder: 'e.g. JOHN DOE'
        },
        postalCode: {
          selector: '#zip-code',
          placeholder: '11111'
        }
      }
    }).then((hostedFieldsInstance: braintree.HostedFields) => {
      
      this.hostedFieldsInstance = hostedFieldsInstance;

      hostedFieldsInstance.on('focus', (event) => {
        const field = event.fields[event.emittedBy];
        const label = this.findLabel(field);
        label?.classList.remove('filled'); // added and removed css classes
      });

      hostedFieldsInstance.on('blur', (event) => {
        const field = event.fields[event.emittedBy];
        const label = this.findLabel(field); // fetched label to apply custom validations
        this.disablePayButton = !!Object.values(event.fields).find(each => each.isValid === false);
        this.cdRef.detectChanges();
      });

      hostedFieldsInstance.on('empty', (event) => {
        const field = event.fields[event.emittedBy];
        // can add custom code for custom validations here
      });

      hostedFieldsInstance.on('validityChange', (event) => {
        const field = event.fields[event.emittedBy];
        const label = this.findLabel(field);
        if (field.isPotentiallyValid) { // applying custom css and validations
          label?.classList.remove('invalid');
        } else {
          label?.classList.add('invalid');
        }

        this.disablePayButton = Object.values(event.fields).some(each => each.isValid === false);
        this.cdRef.detectChanges();

        // can add custom code for custom validations here
      });

    });
  }

  findLabel(field: any) {
    return document.querySelector('.hosted-field--label[for="' + field.container.id + '"]');
  }

  tokenizeUserDetails() {
    this.hostedFieldsInstance.tokenize({cardholderName: this.cardholdersName}).then((payload) => {
      this.creditCardTokenized.emit(payload);
      this.paying.set(true);
      this.cdRef.detectChanges();
    }).catch(() => {
      this.paying.set(false);
      this.cdRef.detectChanges();
    });
  }

}
